module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8.5 12.8L15.9 4c.2-.3.1-.7-.1-.9a.6.6 0 0 0-.4-.1H.6c-.3 0-.6.3-.6.6l.1.4 7.4 8.8a.6.6 0 0 0 1 0z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/triangle-arrow.svg
// module id = 330
// module chunks = 0